import { useQuery } from '@tanstack/react-query';
import { getProductById } from '../../api/apiProducts';
import i18next from 'i18next';

/**
 * Hook to fetch a single product by ID
 */
export const useGetProductById = (id) => {
    const {
        data,
        error,
        isLoading,
        refetch
    } = useQuery({
        queryKey: ['product', id, i18next.language],
        queryFn: () => getProductById(id),
        enabled: !!id,
        retry: false,
    });

    return {
        product: data?.data || null,
        error,
        isLoading,
        refetch
    };
};
